import { render, staticRenderFns } from "./audioTitle.vue?vue&type=template&id=01fb3ece&scoped=true"
import script from "./audioTitle.vue?vue&type=script&lang=js"
export * from "./audioTitle.vue?vue&type=script&lang=js"
import style0 from "./audioTitle.vue?vue&type=style&index=0&id=01fb3ece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb3ece",
  null
  
)

export default component.exports